import { render, staticRenderFns } from "./popupSetting.vue?vue&type=template&id=5a0d05a0&scoped=true"
import script from "./popupSetting.vue?vue&type=script&lang=js"
export * from "./popupSetting.vue?vue&type=script&lang=js"
import style0 from "./popupSetting.vue?vue&type=style&index=0&id=5a0d05a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a0d05a0",
  null
  
)

export default component.exports